import BlogGridView from "../../../commonComponents/blogGridView";

const BlogLoadMoreContainer = () => {
  return <BlogGridView type="load_more" gridSize={3} />;
};

export default BlogLoadMoreContainer;
